"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCustomer = void 0;
var BaseCustomer = /** @class */ (function () {
    function BaseCustomer() {
    }
    return BaseCustomer;
}());
exports.BaseCustomer = BaseCustomer;
//# sourceMappingURL=BaseCustomer.js.map